<template>
    <div class="input-wrapper star-cb-group no-stars-layout">
        <div class="d-inline-block" v-for="option in options" :key="option.value">
            <input type="radio"
                   class="d-none"
                   :id="name + option.value"
                   :name="name"
                   :value="option.value"
                   v-model="value"
                   @change="$emit('input', value)"
            >
            <label
                class="number-selector"
                :class="{active: value === option.value}"
                :for="name + option.value"
            >
                {{option.label}}
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [String, Number],
                default: null
            },
            options: {
                type: Array,
                required: true
            },
            name: {
                type: String,
                required: true
            },
        },
        emits: ['input'],
        methods: {
        }
    }
</script>
